import { useInView } from "react-intersection-observer";
import React from "react";
import Img from "./basic/Img";
import { Swiper, SwiperSlide } from "swiper/react";

// 検索タグ管理用コンポーネント
export default function SearchControl({
    data,
    baseClass = "search",
    checkedCategoryList,
    checkedDayList,
    onCheck = (f) => f,
}) {
    const { ref, inView } = useInView({
        threshold: 0.25,
        triggerOnce: true,
    });
    const categoryList = {
        entame: "エンタメ",
        gurume: "グルメ",
        kokusai: "国際情勢",
        sports: "スポーツ",
        seizi: "政治・経済",
        bungaku: "文学",
        history: "歴史",
    };
    const dayList = { day1: "12/9 Fri", day2: "12/10 Sat" };
    const categoryImgNameMap = {
        entame: "tag01",
        gurume: "tag02",
        kokusai: "tag03",
        sports: "tag04",
        seizi: "tag05",
        bungaku: "tag06",
        history: "tag07",
    };
    const gaCategoryLabels = {
        entame: "entertainment",
        gurume: "gourmet",
        kokusai: "international",
        sports: "sports",
        seizi: "political",
        bungaku: "literature",
        history: "history",
    };
    const gaDayLabels = {
        day1: "1209",
        day2: "1210",
    };

    // チェックボックスが選択された時に呼ぶ関数
    // チェックされたカテゴリと日付のステータスを更新する
    const handleCheck = (target, name, checkedCategoryList, checkedDayList) => {
        let newCheckedCategoryList = checkedCategoryList;
        let newCheckedDayList = checkedDayList;
        if (name === "category") {
            newCheckedCategoryList = checkedCategoryList.includes(target)
                ? checkedCategoryList.filter((item) => item !== target)
                : [...checkedCategoryList, target];
        } else if (name === "day") {
            newCheckedDayList = checkedDayList.includes(target)
                ? checkedDayList.filter((item) => item !== target)
                : [...checkedDayList, target];
        }
        onCheck(data, newCheckedCategoryList, newCheckedDayList);
    };

    // ラベル付きインプット要素のコンポーネント
    // 汎用的でない
    const LabeledInputComponent = ({
        type,
        name,
        itemKey,
        list,
        tagMap,
        checkedCategoryList,
        checkedDayList,
        baseClass,
    }) => {
        return (
            <div
                className={`${baseClass} ${itemKey} ${
                    checkedCategoryList.includes(itemKey) ||
                    checkedDayList.includes(itemKey)
                        ? "checked"
                        : ""
                }`}
            >
                <label>
                    <input
                        type={type}
                        name={name}
                        value={`${name}-${itemKey}`}
                        checked={
                            checkedCategoryList.includes(itemKey) ||
                            checkedDayList.includes(itemKey)
                        }
                        onChange={handleCheck.bind(
                            null,
                            itemKey,
                            name,
                            checkedCategoryList,
                            checkedDayList
                        )}
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "sort",
                                event_label: `sort_${
                                    name === "category"
                                        ? gaCategoryLabels[itemKey]
                                        : gaDayLabels[itemKey]
                                }`,
                            });
                        }}
                    ></input>
                    {tagMap !== null ? <Img fileName={tagMap[itemKey]} /> : ""}
                    <p>{list[itemKey]}</p>
                </label>
            </div>
        );
    };

    const carouselItems = Object.keys(categoryList).map((key) => (
        <SwiperSlide>
            <LabeledInputComponent
                type="checkbox"
                name="category"
                itemKey={key}
                list={categoryList}
                tagMap={categoryImgNameMap}
                checkedCategoryList={checkedCategoryList}
                checkedDayList={checkedDayList}
                key={key}
                baseClass={`${baseClass}-category-list-item`}
            />
        </SwiperSlide>
    ));
    return (
        <div
            ref={ref}
            className={`${baseClass} ${inView && `${baseClass}_anim`}`}
        >
            <div className={`${baseClass}-category`}>
                <div className={`${baseClass}-category_title`}>
                    <p>コンテンツ</p>
                </div>
                <div className={`${baseClass}-category-separate`}></div>
                <div className={`${baseClass}-category-list`}>
                    <Swiper
                        spaceBetween={5}
                        threshold={5}
                        freeMode={true}
                        breakpoints={{
                            0: {
                                slidesPerView: 1.9,
                            },
                            240: {
                                slidesPerView: 2.9,
                            },
                            270: {
                                slidesPerView: 3.9,
                            },
                            330: {
                                slidesPerView: 4.9,
                            },
                            430: {
                                slidesPerView: 5.9,
                            },
                        }}
                    >
                        {carouselItems}
                    </Swiper>
                </div>
            </div>
            <div className={`${baseClass}-day`}>
                <div className={`${baseClass}-day-list`}>
                    {Object.keys(dayList).map((key) => (
                        <LabeledInputComponent
                            type="checkbox"
                            name="day"
                            itemKey={key}
                            list={dayList}
                            tagMap={null}
                            checkedCategoryList={checkedCategoryList}
                            checkedDayList={checkedDayList}
                            key={key}
                            baseClass={`${baseClass}-day-list-item`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
